const CONTACT_FORM_ID = 'contact-form'

const findContactScrollTarget = () =>
  document.getElementById(CONTACT_FORM_ID) ||
  document.querySelector('[data-testid="contact-form"]') ||
  document.getElementById('contact-us') ||
  document.querySelector('[data-testid="consultation-section"]')

const scrollTargetIntoView = (target) => {
  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  if (window.history?.replaceState) {
    window.history.replaceState(null, '', '#contact-us')
  }
}

export function scrollToContactSection() {
  if (typeof document === 'undefined') return false

  let attempts = 0
  const maxAttempts = 24

  const run = () => {
    const formAnchor = document.getElementById(CONTACT_FORM_ID)
    const target = findContactScrollTarget()
    if (!target) return false

    const formReady =
      formAnchor &&
      document.querySelector('[data-testid="contact-form"]')?.offsetHeight > 200

    if (formReady || !formAnchor || attempts >= maxAttempts) {
      scrollTargetIntoView(formAnchor || target)
      return true
    }

    attempts += 1
    window.setTimeout(run, 50)
    return true
  }

  return run()
}
